import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../../user/providers/UserPhoneVerificationProvider";

// Own namespace so the resend cooldown is isolated from the shared registration / home-match phone verification,
// and restartCooldownOnOpen so every promotion submission opens a fresh attempt (sends a code and starts the timer)
// instead of inheriting a stale "code already sent" flag from a previous attempt.
const PHONE_VERIFICATION_STORAGE_KEY_NAMESPACE = "promotionPhoneVerification";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
}

export const PromotionLeadPhoneVerification = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber} = props;

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={onClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                storageKeyNamespace={PHONE_VERIFICATION_STORAGE_KEY_NAMESPACE}
                restartCooldownOnOpen
            />
        </UserPhoneVerificationProvider>
    );
};
import {UserPhoneVerification as UserPhoneVerificationBase} from "@pg-mono/user";

import {UserPhoneVerificationProvider} from "../../../user/providers/UserPhoneVerificationProvider";

// Own namespace so the resend cooldown is isolated from the shared registration / home-match phone verification,
// and restartCooldownOnOpen so every promotion submission opens a fresh attempt (sends a code and starts the timer)
// instead of inheriting a stale "code already sent" flag from a previous attempt.
const PHONE_VERIFICATION_STORAGE_KEY_NAMESPACE = "promotionPhoneVerification";

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
    onChangeNumber: () => void;
}

export const PromotionLeadPhoneVerification = (props: IProps) => {
    const {isOpen, onClose, onSuccess, onChangeNumber} = props;

    return (
        <UserPhoneVerificationProvider>
            <UserPhoneVerificationBase
                isOpen={isOpen}
                onClose={onClose}
                onSuccess={onSuccess}
                onChangeNumber={onChangeNumber}
                storageKeyNamespace={PHONE_VERIFICATION_STORAGE_KEY_NAMESPACE}
                restartCooldownOnOpen
            />
        </UserPhoneVerificationProvider>
    );
};
